import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/fleet-management/')({
  loader: async () => {
    throw redirect({ to: '/fleet-management/vehicles' });
  },
});
